module.exports = __webpack_public_path__ + "img/thumb-up.29b4cb45.webp";